import React, { Component } from 'react';
import axios from "axios"
import { Box, Typography, LinearProgress, Alert, AlertTitle } from '@mui/material';
import { firstDayOfYear } from '../../Stats/statsFunctions';

class DownloadProgress extends Component {
    state = { 
        progress_value: 0,
        total: 0,
        status: "FETCHING"
    }

    componentDidMount = () => {
        this.generateCSV()
    }
    stopLoading = () => {
        this.props.handleLoading()
    }
    generateCSV = async ()  => {
        const {start_date, end_date, url, project_id, bank_id, budget_year, isBudget, user_id, op_id, op_type, session_id, employeeID} = this.props;
        console.log('====================================');
        console.log("generateCSV", {start_date, end_date, url, project_id, bank_id, budget_year, isBudget, user_id, op_id, op_type, session_id});
        console.log('====================================');
        
        try {
            let data = {start_date: start_date || firstDayOfYear, end_date: end_date || new Date()}
            if (project_id) {
                data = {
                    project_id,
                    dates: data
                }
            } 
            if (session_id) { // demands session
                data = {
                    session_id,
                }
            } 
            if (op_id && op_type) {
                const LIST = {
                    "project": ` contains(spending_project , '${op_id}') `, 
                    "label": ` contains(spending_labels , '${op_id}') `, 
                    "supplier": ` spending_supplier = '${op_id}'`,
                    // "supplier": ` spending_supplier = '${op_id}'`,
                    "category": ` spending_category = '${op_id}'`,
                }

                data.andOpt =  LIST[op_type]
                  
            } 
            if (url == "/extract/timesheets/employee" && employeeID) {
                data.item_id = employeeID
            } 
            if (bank_id) {
                data.item_id = bank_id
            } 
            if (user_id) {
                data.item_id = user_id
            } 

            if (budget_year && isBudget) {
                data = budget_year
            } 
            let res = await axios.post(url, {data})
            
            if(!res.data.error){
                let process_id = res.data
                // this.props.setProcess({process_id})
                this.checkStatus(process_id)
            } else {
                console.log("[ERROR] generateCSV ", res.data.error);
                this.stopLoading()
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] generateCSV ", error);
            console.log('====================================');
            this.stopLoading()
        }
    }

    checkStatus = async (process_id) => {
        // GET STATUS
        let res = await axios.post('/extract/status', {process_id})
        console.log('==============IN checkStatus ======================');
        console.log({res: res.data});
        console.log('====================================');
        if(!res.data.error){
            if (res.data.status === "COMPLETED"){
                this.setState({ progress_value: 100 })
                this.downloadCSV(process_id)
                this.stopLoading()
            } else {
                if(res.data.actual && res.data.total) {
                    this.setState({ progress_value: res.data.actual / res.data.total * 100, status: res.data.status, total: res.data.total })
                }
                setTimeout(() => this.checkStatus(process_id), 3000)
            }
        } else {
            console.log("[ERROR] checkStatus ", res.data.error);
            this.stopLoading()
        }
    }
    
    downloadCSV = async (process_id)  => {
        // this.stopLoading({loading: true})
        console.log('====================================');
        console.log("downloadCSV");
        console.log('====================================');
        if (this.props.clearData) {
            this.props.clearData()
        }
        try {
            let res = await axios.post('/extract/download', {process_id})
            let title = this.props.title || "MyJouleBox-Compta.csv" 
            if(!res.data.error){
                this.startDownload(res.data, title)
            } else {
                console.log("[ERROR] downloadCSV ", res.data.error);
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] downloadCSV ", error);
            console.log('====================================');
        }
        this.stopLoading()
    }

    startDownload = (href, title) => {
        const link = document.createElement('a');
        link.href = "data:application/csv;charset=utf-8," + encodeURIComponent(href);
        link.setAttribute('download', title);

        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
    }


    render() {
        return (
            <Box>
                <Alert severity="info">
                    <AlertTitle>
                        {this.state.status === "PENDING" &&
                            "Etape 2 / 2"
                        }
                        {(this.state.status === "FETCHING" || this.state.total === 0) &&
                            "Etape 1 / 2"
                        }
                    </AlertTitle>
                        {this.state.status === "PENDING" &&
                            "Téléchargement en cours"
                        }
                        {(this.state.status === "FETCHING" || this.state.total === 0) &&
                            "Préparation des données"
                        }
                    {/* <LinearProgress /> */}
                    <Box display="flex" alignItems="center">
                        <Box width="100%" mr={1}>
                            <LinearProgress variant={this.state.progress_value > 0 ? "determinate" : "indeterminate"} value={this.state.progress_value && this.state.progress_value} />
                        </Box>
                        <Box minWidth={35}>
                            <Typography variant="body2" color="textSecondary">{`${Math.round(
                                this.state.progress_value,
                            )}%`}</Typography>
                        </Box>
                    </Box>
                </Alert>
            </Box>

            
        );
    }
}

export default DownloadProgress;